import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useDatepickerStore = defineStore('Datepicker', () => {
  const useDateRange = ref(false)
  const inventory = ref(null)
  const disabledDates = ref(null)
  const enabledDates = ref(null)
  const dateRange = ref({
    checkIn: null,
    checkOut: null
  })
  const settings = ref({
    currentDate: null,
    currentTime: null
  })

  function setInventory(payload) {
    inventory.value = payload
  }
  function setDateRange(payload) {
    dateRange.value.checkIn = payload[0]
    dateRange.value.checkOut = payload[1]
  }
  function enableDateRange(payload) {
    useDateRange.value = payload
  }
  function setDisabledDates(payload) {
    disabledDates.value = payload
  }
  function setEnabledDates(payload) {
    enabledDates.value = payload
  }
  function appendInventory(payload) {
    inventory.value = { ...inventory.value, ...payload }
  }
  function appendDisabledDates(payload) {
    disabledDates.value.dates.push(...payload)
  }
  function setTimeSettings(payload) {
    settings.value = payload
  }

  return {
    useDateRange,
    inventory,
    disabledDates,
    enabledDates,
    dateRange,
    settings,

    setInventory,
    setDateRange,
    enableDateRange,
    setDisabledDates,
    setEnabledDates,
    appendInventory,
    appendDisabledDates,
    setTimeSettings
  }
})
